import $ from 'jquery';

function SingleChild(element) {
  this.element = element;
  this.$element = $(element);
  this.init();
  this.ready();
}

SingleChild.prototype = {
  init() {
    const columns = this.$element.find('.home-programs-col');
    columns.each((i, elem) => {
      const $elem = $(elem);
      if ($elem.find('.views-row').length === 1) {
        $elem.addClass('single-child');
      } else if ($elem.find('.views-row').length === 3) {
        $elem.addClass('three-children');
      } else if ($elem.find('.views-row').length === 2) {
        $elem.addClass('two-children');
      }
    });
  },
  ready() { this.$element.addClass('ready'); },
};

export default SingleChild;
